(function($) {

    init()

    function init() {
        menuPC()
        height()
        specializations()
        changeImage()
        hamburgerPc()
        hover()
    }

    function menuPC() {
        $('.hamburger-pc').on('click', function() {
            $('.menu-pc').addClass('active');
        });

        $('.menu-pc-close').on('click', function() {
            $('.menu-pc').removeClass('active');
        });
    }


    function height() {
        if (window.matchMedia("(min-width: 992px)").matches) {
            var maxHeight = Math.max.apply(null, $(".home-news-row .home-news-slider a .text .title").map(function() {
                return $(this).innerHeight();
            }).get());
            $(".home-news-row .home-news-slider a .text .title").height(maxHeight);

            var typoHeight = $('.home-office .typo-block').height();
            var newTypoHeight = typoHeight + 130;
            $(".home-office .home-office-btn").css("top", newTypoHeight);

        }

    }

    function specializations() {
        $('.home-specializations li a').hover(function(e) {
            $(this).find('img').fadeIn();
        }, function() {
            $('.home-specializations li a img').hide();
        });

        // Aktualizacja pozycji obrazka w zależności od kursora
        $('.home-specializations li a').mousemove(function(e) {
            var offset = $(this).offset();
            var relX = e.pageX - offset.left;
            var relY = e.pageY - offset.top;
            var img = $(this).find('img');

            var imgWidth = img.width() / 2;
            var imgHeight = img.height() / 2;

            // Ustawiamy pozycję obrazka
            img.css({
                left: (relX) + 20 + 'px', // Wyśrodkowanie w poziomie
                top: (relY - imgHeight) + 20 + 'px' // Wyśrodkowanie w pionie
            });
        });
    }

    // CHANGEIMAGE
    function changeImage() {
        const $mainImage = $('#main-image');
        let currentAccordionId = null; // Przechowuje aktualny id akordeonu

        $('.accordion a').on('mouseenter', function() {
            // Pobierz id rodzica akordeonu
            const accordionId = $(this).closest('.accordion').attr('id');

            // Sprawdź, czy id jest inne niż aktualne
            if (accordionId !== currentAccordionId) {
                currentAccordionId = accordionId;

                // Ustaw odpowiedni obraz w zależności od id
                let newImage;
                switch (accordionId) {
                    case 'biznes':
                        newImage = "/wp-content/uploads/2024/12/img-biznes-hero.jpg";
                        break;
                    case 'agrobiznes-i-rolnictwo':
                        newImage = "/wp-content/uploads/2024/12/bg-agrobiznes.jpg";
                        break;
                    case 'klienci-indywidualni':
                        newImage = "/wp-content/uploads/2024/12/img-indywidualni-hero.jpg";
                        break;
                    default:
                        newImage = "/wp-content/uploads/2024/12/bg-agrobiznes.jpg";
                }

                // Dodaj animację zmiany obrazu przez zmianę opacity
                $mainImage.css('transition', 'opacity 0.8s');
                $mainImage.css('opacity', '0');
                setTimeout(() => {
                    $mainImage.attr('src', newImage);
                    $mainImage.css('opacity', '1');
                }, 200);
            }
        });

        // $('.accordion').on('mouseleave', function () {
        //     // Przywróć domyślny obraz z animacją
        //     currentAccordionId = null;
        //     $mainImage.fadeOut(200, function () {
        //         $mainImage.attr('src', "/wp-content/uploads/2024/12/bg-agrobiznes.jpg").fadeIn(200);
        //     });
        // });
    }

    function hamburgerPc() {
        const $hamburger = $('.hamburger-pc');
        const $slider = $('.slider');

        $(window).on('scroll', function() {
            const sliderBottom = $slider.offset().top + $slider.outerHeight(); // Dolna krawędź slidera
            const windowTop = $(window).scrollTop(); // Górna krawędź widocznego obszaru

            if (sliderBottom <= windowTop) {
                $hamburger.addClass('visible');
            } else {
                // Jeśli slider jest nadal widoczny w obszarze widocznym
                $hamburger.removeClass('visible');
            }
        });

        const $specializations = $('.specializations-list');

        if ($specializations.length > 0) {
            $(window).on('scroll', function() {
                const specializationsTop = $specializations[0].getBoundingClientRect().top;

                if (specializationsTop <= 0) {
                    $hamburger.addClass('white');
                } else {
                    $hamburger.removeClass('white');
                }
            });
        }
    }


    // HOVER
    function hover() {
        $('.navbar-fixed-main-nav li a').hover(
            function() {
                $(this).closest('li').addClass('hover');  // Dodanie klasy hover
            }, 
            function() {
                $(this).closest('li').removeClass('hover');  // Usunięcie klasy hover
            }
        );
    }



    // ALL

    if ('loading' in HTMLImageElement.prototype) {
        const images = document.querySelectorAll('img[loading="lazy"]');
        images.forEach(img => {
            img.src = img.dataset.src;
        });
    } else {
        // Dynamically import the LazySizes library
        const script = document.createElement('script');
        script.src =
            'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.1.2/lazysizes.min.js';
        document.body.appendChild(script);
    }


    // PLACEHOLDER
    $('input,textarea').focus(function() {
        $(this).data('placeholder', $(this).attr('placeholder'))
            .attr('placeholder', '');
    }).blur(function() {
        $(this).attr('placeholder', $(this).data('placeholder'));
    });

}(jQuery));